import appStore from "@/stores/appStore";
import { useNavigate } from "react-router-dom";

const useNavigateTo = () => {
  const navigate = useNavigate();
  const navigateTo = (url) => {
    console.log(appStore.isInFrame);

    if (appStore.isInFrame) {
      navigate(url);
    } else {
      window.open(url, "_blank");
    }
  };

  return {
    navigateTo,
  };
};

export default useNavigateTo;
